/// global
import { Atom, state } from ":mods";

export const $toast_group = state.createGlobal<Atom.Alert.model.ToastMessage[]>([]);
export const actions = {
  pushToast(alert: Atom.Alert.model.ToastMessage) {
    $toast_group.set((s) => [...s, alert]);
  },
};
